import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-load",
  "use": "icon-load-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" class=\"lds-dual-ring\" id=\"icon-load\">\n    <circle cx=\"50\" cy=\"50\" ng-attr-r=\"{{config.radius}}\" ng-attr-stroke-width=\"{{config.width}}\" ng-attr-stroke=\"{{config.stroke}}\" ng-attr-stroke-dasharray=\"{{config.dasharray}}\" fill=\"none\" stroke-linecap=\"round\" r=\"27\" stroke-width=\"7\" stroke=\"#409eff\" stroke-dasharray=\"42.411500823462205 42.411500823462205\" transform=\"rotate(60 50 50)\">\n      <animateTransform attributeName=\"transform\" type=\"rotate\" calcMode=\"linear\" values=\"0 50 50;360 50 50\" keyTimes=\"0;1\" dur=\"1s\" begin=\"0s\" repeatCount=\"indefinite\" />\n    </circle>\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/load.svg
// module id = u7Bn
// module chunks = 148